
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { useRouter } from 'next/router'
import { ReactElement, useContext, useEffect, useState } from 'react'
import { NotFound } from '@jconradi/tutu-porn-components/components/Errors/NotFound/NotFound'
import { ProfileSidebar } from '@jconradi/tutu-porn-components/components/Profile/ProfileSidebar/ProfileSidebar'
import { useUser } from '@jconradi/tutu-porn-components/hooks/useUser'
import { MediaFeed } from '@jconradi/tutu-porn-components/components/Media/MediaFeed/MediaFeed'
import { DefaultCount, useMediaParams } from '@jconradi/tutu-porn-components/components/Media/MediaFeed/useMediaParams'
import { MediaSearchOrder, MediaSearchQuery, searchMedia } from '@jconradi/tutu-porn-api-client/src/media'
import { getUser, searchUsers, UserResponse } from '@jconradi/tutu-porn-api-client/src/users'
import { AxiosResponse } from 'axios'
import { dehydrate, QueryClient, useQueryClient } from '@tanstack/react-query'
import { AuthContext } from '@jconradi/tutu-porn-components/contexts/AuthContext'
import { getLayout } from '../../components/Layout/Layout'

const UserMediaSearch: MediaSearchQuery = {
    order: MediaSearchOrder.Latest,
    page: 0,
    count: DefaultCount
}

export default function Users() {
    const router = useRouter();
    const { username } = router.query;
    const { jwtData } = useContext(AuthContext);
    const userQuery = useUser(username as string);
    const queryClient = useQueryClient();

    useEffect(() => {
        // Refresh the query if it's our own page (invalidate the SSG media list)
        if (username && username == jwtData?.username) {
            queryClient.invalidateQueries(['media'])
        }
    }, [username, queryClient, jwtData?.username])

    if (!userQuery.isLoading && !userQuery.data) {
        return <NotFound />
    }

    return (
        <section className='flex flex-col lg:flex-row w-full h-full gap-y-8'>
            <ProfileSidebar />
            <MediaFeed className="lg:ml-4" username={username} query={{
                ...UserMediaSearch,
                username
            }} loading={router.isReady} />
        </section>
    )
}

Users.getLayout = (page: ReactElement) => getLayout(page);

export async function getStaticPaths() {
    return { paths: [], fallback: 'blocking' }
}

 async function _getStaticProps({ params }: any) {
    const { username } = params;
    const queryClient = new QueryClient();

    const user = await getUser(username);

    if (user.status === 404) {
        return {
            notFound: true
        }
    }

    await queryClient.prefetchQuery(['users', 'username', username], () => {
        return user.data;
    });

    const userMediaQuery = { ...UserMediaSearch, username };
    await queryClient.prefetchQuery(['media', userMediaQuery], async () => {
        const media = await searchMedia(userMediaQuery);

        return media.data;
    });

    return {
        props: {
            dehydratedState: dehydrate(queryClient)
        },
        // Next.js will attempt to re-generate the page:
        // - When a request comes in
        // - At most once every 60 seconds
        revalidate: 1, // In seconds
    }
}

// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/users/[username]',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  